<div class="ui-g-12">
    <div class="card flex justify-content-center">
        <p-dialog header="Basic Info" [(visible)]="visible" [modal]="true" [style]="{ width: 'auto' }"
            [draggable]="false" [resizable]="false" [responsive]="true" [closable]="true" (onHide)="cancel()">
            <div style="text-align: center">
                <p style="color: black;margin-bottom: 10px;font-size: 19px;font-weight: bold;">
                    Just a step away from starting your Dr. consultation!
                </p>
            </div>
            <div class="form-unit">
                <label class="form-unit-label" style="display: block; margin-bottom: 5px; font-weight: bolder">Date Of
                    Birth*</label>
                <p-calendar class="pCalender custom-calendar" class="notranslate" [defaultDate]="dateTime"
                    [maxDate]="dateTime" [style]="{ width: '100%' }" dateFormat="dd/mm/yy" [monthNavigator]="true"
                    [yearNavigator]="true" yearRange="1900:3099" placeholder="dd/mm/yyyy" yearRange="1900:2025"
                    [inputStyle]="{
            width: '100%','border-radius': '50rem','padding-left': '10px'}"
                    placeholder="Select date of birth(DD/MM/YYYY)" [(ngModel)]="dob"
                    (ngModelChange)="enableContinueButton()" [showButtonBar]="true"
                    [todayButtonStyleClass]="'hideTodayButton'"></p-calendar>
            </div>

            <div class="form-unit">
                <label class="form-unit-label"
                    style="display: block; margin-bottom: 5px; font-weight: bolder">State*</label>
                <p-dropdown styleClass="input-pill input-dropdown-pill notranslate" [options]="stateList"
                    [filter]="true" [(ngModel)]="selectedState" (ngModelChange)="enableContinueButton()"
                    placeholder="Choose Your State" optionLabel="name" [virtualScroll]="true"
                    inputId="float-label"></p-dropdown>
            </div>
            <div class="form-unit">
                <label class="form-unit-label"
                    style="display: block; margin-bottom: 5px; font-weight: bolder">Gender*</label>
                <p-dropdown styleClass="input-pill input-dropdown-pill" [options]="gender" [(ngModel)]="selectedGender"
                    (ngModelChange)="enableContinueButton()" placeholder="Choose Your Gender" optionLabel="name"
                    inputId="float-label"></p-dropdown>
            </div>
            <div class="form-unit">
                <label class="form-unit-label" style="display: block; margin-bottom: 5px; font-weight: bolder">Email
                    (Optional)</label>
                <input class="form-control input-pill" pInputText id="username" placeholder="Enter Your Email"
                    [(ngModel)]="email" (ngModelChange)="enableContinueButton()" />

                <!-- <span>
                    <input class="form-control inputdd1"  pInputText id="username" placeholder="Enter Received OTP"
                            [(ngModel)]="token" />
                            <p-button label="{{otpText}}" [style]="{'border-radius':'25px','margin-left':'10px'}" (click)="toggleInput()"></p-button>
                    <p-progressSpinner [style]="{width: '30px', height: '25px','margin-top': '15px'}"  *ngIf="isSpinning"></p-progressSpinner>
                    
                </span> -->
            </div>
            <div class="form-unit">
                <label for="unid" class="form-unit-label"
                    style="display: block; margin-bottom: 5px; font-weight: bolder">Unique Identification Type <span
                        class="req">*</span> :</label>
                <p-dropdown id="unid" [options]="this.unique_id" [(ngModel)]="this.identification_type"
                    placeholder="Select" [style]="{ width: '155px' }" name="unique_id_name" #unique_id_name="ngModel"
                    required>
                </p-dropdown>
            </div>
            <div class="form-unit">
                <label for="unid" class="form-unit-label"
                    style="display: block; margin-bottom: 5px; font-weight: bolder">Unique Identification File <span
                        class="req">*</span> :</label>
                <p-fileUpload name="unique_id_file" (onSelect)="uploadUniqueIDFiles($event.files)"
                    [showUploadButton]="false" styleClass="p-fileUpload-label-fix"
                    [disabled]="!this.identification_type" [maxFileSize]="5033165" (onRemove)="resetUnquieIDUpload()"
                    [showCancelButton]="false" [multiple]="false" [fileLimit]="1" accept="image/*" required>
                </p-fileUpload>
                <div class="alert alert-danger" role="alert">
                    <p class="text-center text-gray-underline">
                        <span class="font-weight-bold">Note</span>: The file types
                        supported for Unique Identification are JPEG, JPG or PNG.
                    </p>
                </div>
            </div>


            <div class="ui-g" style="text-align: center">
                <div class="ui-g-12">
                    <p-button class="form-unit-member buttonsubmit" [disabled]="disableButton" [style]="{
              width: '215px',
              height: '35px',
              'border-radius': '25px'
            }" label="Continue" (click)="onPopUpSubmit()"></p-button>
                </div>
            </div>
            <p style="font-weight: bolder; color: red">{{ errorText }}</p>
            <div class="ui-g-12">
                <app-error-messages [api_result]="this.server_error">
                </app-error-messages>
            </div>
        </p-dialog>

        <p-toast></p-toast>
    </div>

    <p-tabView [(activeIndex)]="this.consultation.other_data.tabview_Data.selected_tab">
        <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Consult Doctor Form" leftIcon="pi pi-pencil">
            <form accept-charset="UTF-8" #consultDoctorForm="ngForm" (submit)="nextTab()">
                <div class="ui-g">
                    <div class="ui-g-12">
                        <p-fieldset [style]="{ border: '1px solid #000000' }">
                            <p-header><b>Choose a member</b></p-header>
                            <div class="ui-g">
                                <div class="ui-g-12">
                                    <div class="ui-g">
                                        <div class="ui-g-12 ui-md-12 ui-lg-6">
                                            <div class="ui-g-12">
                                                <div class="ui-g-12 ui-lg-6">
                                                    <label for="choose_member">
                                                        Choose a member<span class="req">*</span>:
                                                    </label>
                                                </div>
                                                <div class="ui-g-12 ui-lg-6">
                                                    <p-dropdown class="notranslate" id="choose_member" [(ngModel)]="
                              this.consultation.consultApiData.patient_guid
                            " placeholder="Select" [options]="
                              this.consultation.other_data.members_data
                            " #member="ngModel" name="member" (ngModelChange)="onMemberChange()" (onChange)="dirty()"
                                                        [required]="true">
                                                    </p-dropdown>

                                                    <div *ngIf="
                              member.invalid && (member.dirty || member.touched)
                            " class="alert alert-danger">
                                                        <div *ngIf="member.errors.required" class="alert alert-danger">
                                                            Member selection is required.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="ui-g-12">
                                                <div class="ui-g-12 ui-lg-6">
                                                    <label for="add_member">If member is not in the list</label>
                                                </div>
                                                <div class="ui-g-12 ui-lg-6">
                                                    <button pButton type="button" label="Add New Member"
                                                        icon="fa fa-user"
                                                        [routerLink]="['/', this.slug, 'patient', 'members', 'add']"></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </p-fieldset>
                        <ng-container>
                            <p-fieldset [style]="{ border: '1px solid #000000' }" *ngIf="
                  !this.consultation.other_data.user_packages_list_api_result
                    .Posting
                ">
                                <p-header><b>Select Consultation Type</b></p-header>
                                <div class="ui-g">
                                    <div class="ui-lg-4 ui-md-6 ui-g-12" *ngIf="!this.is_uk_country">
                                        <p-radioButton name="consultation_type_id" [value]="
                        this.consultation.const_data.CONSULTATION_TYPES
                          .PRIMARY_MEDICAL_CONSULTATION
                      " label="Primary Medical Consultation" [(ngModel)]="
                        this.consultation.consultApiData.consultation_type_id
                      " (ngModelChange)="onConsultationChange()" #consultation_type="ngModel" (click)="notDirty()"
                                            [disabled]="isPosting()" required>
                                        </p-radioButton>
                                    </div>
                                    <div class="ui-lg-4 ui-md-6 ui-g-12">
                                        <p-radioButton name="consultation_type_id"
                                            [value]="this.consultation.const_data.CONSULTATION_TYPES.EXPERT_SECOND_MEDICAL_CONSULTATION"
                                            [label]="this.is_uk_country?'Specialist Consultation':'Expert Second Medical Opinion'"
                                            [(ngModel)]="this.consultation.consultApiData.consultation_type_id"
                                            (ngModelChange)="onConsultationChange()" #consultation_type="ngModel"
                                            (click)="notDirty()" [disabled]="isPosting()" required>
                                        </p-radioButton>
                                    </div>

                                    <div class="ui-lg-4 ui-md-6 ui-g-12" *ngIf="!this.is_uk_country">
                                        <p-radioButton name="consultation_type_id" [value]="
                        this.consultation.const_data.CONSULTATION_TYPES
                          .MULTI_SPECIALTY_CONSULTATION
                      " label="Multi Specialty Consultation" [(ngModel)]="
                        this.consultation.consultApiData.consultation_type_id
                      " (ngModelChange)="onConsultationChange()" #consultation_type="ngModel" (click)="notDirty()"
                                            [disabled]="isPosting()" required>
                                        </p-radioButton>
                                    </div>
                                    <div class="ui-lg-4 ui-md-6 ui-g-12">
                                        <p-radioButton name="consultation_type_id" [value]="
                        this.consultation.const_data.CONSULTATION_TYPES
                          .FOLLOW_UP_CONSULTATION
                      " label="Follow Up Consultation" [(ngModel)]="
                        this.consultation.consultApiData.consultation_type_id
                      " (ngModelChange)="onConsultationChange()" #consultation_type="ngModel" (click)="notDirty()"
                                            [disabled]="isPosting()" required>
                                        </p-radioButton>
                                    </div>
                                    <div class="ui-lg-4 ui-md-6 ui-g-12"
                                        *ngIf="this.is_primary_provider && !this.is_uk_country">
                                        <p-radioButton name="consultation_type_id" [value]="
                        this.consultation.const_data.CONSULTATION_TYPES
                          .NUTRITION_AND_HEALTH_CONSULTATION
                      " label="Diet and Nutrition" [(ngModel)]="
                        this.consultation.consultApiData.consultation_type_id
                      " (ngModelChange)="onConsultationChange()" #consultation_type="ngModel" (click)="notDirty()"
                                            [disabled]="isPosting()" required>
                                        </p-radioButton>
                                        <a [routerLink]="['/', this.slug, 'patient', 'nutrition-and-health']">[Learn
                                            More]</a>

                                    </div>
                                </div>
                            </p-fieldset>

                            <ng-container *ngIf="isConsultationSelected()">
                                <p-fieldset *ngIf="
                    !this.consultation.other_data.user_packages_list_api_result
                      .Posting &&
                    this.consultation.other_data.user_packages_list_api_result
                      .PromiseResult.success
                  " [style]="{ border: '1px solid #000000' }">
                                    <p-header><b>Payment Options</b></p-header>
                                    <div class="ui-g">
                                        <div class="ui-g-12" *ngIf="this.consultation.other_data.packages_status_data.length != 0 && !this.is_uk_country">
                                            <p-radioButton name="payment_option" [value]="false" label="Use my Package"
                                                [(ngModel)]="this.consultation.other_data.is_pay"
                                                #payment_option="ngModel" (ngModelChange)="onPaymentChange()" required
                                                [disabled]="isPosting()">
                                            </p-radioButton>
                                            <p>
                                                (By selecting the package 1 consultation will be used
                                                from selected package)
                                            </p>
                                            <ng-container *ngIf="!isPay()">
                                                <div class="ui-g pl-5rem" *ngFor="
                            let package of this.consultation.other_data
                              .packages_status_data
                          ">
                                                    <div class="ui-g-12">
                                                        <p-radioButton name="package_option" [value]="package.id"
                                                            [label]="package.final_name" [(ngModel)]="
                                this.consultation.consultApiData.user_package_id
                              " (ngModelChange)="onUserPackageChange()" #package_option="ngModel"
                                                            [disabled]="isPosting()"
                                                            [required]="!this.consultation.other_data.is_pay">
                                                        </p-radioButton>
                                                        <p class="alert-success">
                                                            ({{ text(package.user_package_count) }})
                                                        </p>
                                                        <p class="alert-success">
                                                            (Valid Till -
                                                            {{ package.expires_at | date: ' MMM dd, YYYY' }})
                                                        </p>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>

                                        <div class="ui-g-12">
                                            <p-radioButton name="payment_option" [value]="true"
                                                label="Pay for consultation"
                                                [(ngModel)]="this.consultation.other_data.is_pay"
                                                #payment_option="ngModel" (ngModelChange)="onPaymentChange()" required
                                                [disabled]="
                          isPosting() ||
                          this.consultation.other_data.packageConsultDoctor
                            .otherData.packagesDiabled
                        ">
                                            </p-radioButton>
                                        </div>
                                    </div>
                                </p-fieldset>

                                <p-fieldset [style]="{ border: '1px solid #000000' }" *ngIf="
                    isNutritionAndHealthConsultation() &&
                    !this.consultation.other_data.priority_list_api_result
                      .Posting
                  ">
                                    <p-header><b>Select Plan Type</b></p-header>
                                    <ng-container *ngFor="
                      let diet_consultation of this.consultation.other_data
                        .nutritionHealthCons.plans.plans_list
                    ">
                                        <div class="ui-lg-4 ui-md-6 ui-g-12">
                                            <p-radioButton name="nutrition_and_health_consultation_type_id"
                                                [value]="diet_consultation.value"
                                                [label]="diet_consultation.consultation_name" [(ngModel)]="
                          this.consultation.other_data.selectedDietPlan
                        " #nutrition_and_health_consultation_type_id="ngModel" [disabled]="isPosting()"
                                                (click)="notDirty()" required>
                                            </p-radioButton>
                                        </div>
                                    </ng-container>
                                    <app-error-messages [api_result]="
                      this.consultation.other_data.priority_list_api_result
                    ">
                                    </app-error-messages>
                                </p-fieldset>

                                <p-fieldset [style]="{ border: '1px solid #000000' }" *ngIf="isConsultationForm()">
                                    <p-header><b>Consultation Form</b></p-header>
                                    <div class="ui-g">
                                        <div class="ui-g-12">
                                            <div class="ui-g">
                                                <div class="ui-g-12 ui-md-12 ui-lg-6">
                                                    <ng-container *ngIf="
                              !this.consultation.other_data
                                .closed_consultation_list_api_result.Posting &&
                              isFollowUp()
                            ">
                                                        <div class="ui-g-12">
                                                            <div class="ui-g-12 ui-lg-6">
                                                                <label for="consultation_request_number">
                                                                    Choose your Consultation Request Number<span
                                                                        class="req">*</span>:
                                                                </label>
                                                            </div>
                                                            <div class="ui-g-12 ui-lg-6">
                                                                <p-dropdown id="consultation_request_number"
                                                                    [(ngModel)]="
                                    this.consultation.other_data
                                      .selectedClosedConsultation
                                  " placeholder="Select" [options]="
                                    this.consultation.other_data
                                      .close_consultation_data
                                  " #consultation_request_number="ngModel" name="consultation_request_number"
                                                                    (ngModelChange)="onClosedConsultationChange()"
                                                                    (onChange)="dirty()" [required]="true">
                                                                </p-dropdown>

                                                                <div *ngIf="
                                    this.consultation.other_data
                                      .close_consultation_data.length != 0 &&
                                    consultation_request_number.invalid &&
                                    (consultation_request_number.dirty ||
                                      consultation_request_number.touched)
                                  " class="alert alert-danger">
                                                                    <div *ngIf="
                                      consultation_request_number.errors
                                        .required
                                    " class="alert alert-danger">
                                                                        Consultation Request Number is required.
                                                                    </div>
                                                                </div>

                                                                <div *ngIf="
                                    !this.consultation.other_data
                                      .closed_consultation_list_api_result
                                      .Posting &&
                                    this.consultation.other_data
                                      .close_consultation_data.length == 0
                                  " class="alert alert-danger">
                                                                    <div class="alert alert-danger">
                                                                        No Past Consultations found for this member.
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                    <ng-container *ngIf="!isFollowUp() && isSpecialtyDisplay()">
                                                        <div class="ui-g-12">
                                                            <div class="ui-g-12 ui-lg-6">
                                                                <label for="choose_specialty">
                                                                    Choose your specialty<span class="req">*</span>:
                                                                </label>
                                                            </div>
                                                            <ng-container
                                                                *ngIf="isPackageSpecialty(); else show_dropdown">
                                                                <p style="margin-top: 7px">
                                                                    {{
                                                                    this.consultation.other_data
                                                                    .packageConsultDoctor.otherData
                                                                    .specialty_name
                                                                    }}
                                                                </p>
                                                            </ng-container>
                                                            <ng-template #show_dropdown>
                                                                <!-- Single-Specialty -->
                                                                <div *ngIf="!isMultiSpecialtyConsultation()"
                                                                    class="ui-g-12 ui-lg-6">
                                                                    <p-dropdown id="choose_specialty" [options]="
                                      this.consultation.other_data
                                        .specialty_data
                                    " name="speciality" [filter]="true" [filterBy]="'label'" [(ngModel)]="
                                      this.consultation.other_data
                                        .selectedSpecialtyId
                                    " (ngModelChange)="onSpecialityChange()" placeholder="Select" #speciality="ngModel"
                                                                        (onChange)="dirty()" [required]="true">
                                                                    </p-dropdown>
                                                                    <div *ngIf="
                                      speciality.invalid &&
                                      (speciality.dirty || speciality.touched)
                                    " class="alert alert-danger">
                                                                        <div *ngIf="speciality.errors.required"
                                                                            class="alert alert-danger">
                                                                            Specialty is required.
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <!-- Multi-Specialty -->
                                                                <div *ngIf="isMultiSpecialtyConsultation()"
                                                                    class="ui-g-12">
                                                                    <p-multiSelect id="choose_specialty" [options]="
                                      this.consultation.other_data
                                        .specialty_data
                                    " name="speciality" [(ngModel)]="
                                      this.consultation.consultApiData
                                        .specialty_id
                                    " (ngModelChange)="onSpecialityChange()" placeholder="Select" #speciality="ngModel"
                                                                        (onChange)="dirty()" [maxSelectedLabels]="3"
                                                                        [selectedItemsLabel]="'{0} items selected'"
                                                                        required>
                                                                    </p-multiSelect>
                                                                    <div *ngIf="
                                      speciality.invalid &&
                                      (speciality.dirty || speciality.touched)
                                    " class="alert alert-danger">
                                                                        <div *ngIf="speciality.errors.required"
                                                                            class="alert alert-danger">
                                                                            Specialty is required.
                                                                        </div>
                                                                    </div>
                                                                    <div *ngIf="
                                      this.consultation.consultApiData
                                        .specialty_id?.length > 0 &&
                                      this.consultation.consultApiData
                                        .specialty_id?.length <= 1
                                    " class="alert alert-danger">
                                                                        Please select at least 2 specialties.
                                                                    </div>
                                                                </div>
                                                            </ng-template>
                                                        </div>
                                                    </ng-container>

                                                    <div class="ui-g-12">
                                                        <div class="ui-g-12">
                                                            <label for="condition_description">
                                                                Describe your medical conditions / issues
                                                                <span class="req">*</span>:
                                                            </label>
                                                        </div>
                                                        <div class="textarea-container">
                                                            <div class="info-icon-container">
                                                                <textarea [pKeyFilter]="
                                    this.consultation.regExp.textarea
                                  " [(ngModel)]="
                                    this.consultation.consultApiData
                                      .condition_description
                                  " name="condition_description" class="WordWrap format-lines textarea-input height-100px btn-text-box"
                                                                    [maxlength]="
                                    this.consultation.const_data
                                      .CONDITION_DESCRIPTION
                                  " pInputTextarea #details="ngModel" name="details" required></textarea>
                                                                <i class="pi pi-info-circle info-icon"
                                                                    (mouseenter)="showOverlayPanel()"
                                                                    (mouseleave)="hideOverlayPanel()"></i>
                                                            </div>
                                                            <div class="info-overlay"
                                                                [ngClass]="{ show: isOverlayPanelVisible }">
                                                                <span>Enter your symptoms here: <br />
                                                                    For eg.: Fever , cold , diarrhea etc</span>
                                                            </div>
                                                        </div>

                                                        <div class="ui-g-12">
                                                            <div *ngIf=" details.invalid && (details.dirty || details.touched)"
                                                                class="alert alert-danger">
                                                                <div *ngIf="details.errors.required"
                                                                    class="alert alert-danger">
                                                                    Medical condition is required.
                                                                </div>
                                                            </div>
                                                            <div class="ui-g-12">
                                                                <p [style.color]="
                                                this.consultation.consultApiData
                                      .condition_description.length -
                                                  (this.consultation.const_data.CONDITION_DESCRIPTION - 1) >
                                                0
                                                  ? 'red'
                                                  : 'green'
                                              ">
                                                                    {{
                                                                    this.consultation.const_data.CONDITION_DESCRIPTION +
                                                                    1 -
                                                                    this.consultation.consultApiData
                                                                    .condition_description.length < 0 ? 0 :
                                                                        this.consultation.const_data.CONDITION_DESCRIPTION
                                                                        - this.consultation.consultApiData
                                                                        .condition_description.length }} of {{
                                                                        this.consultation.const_data.CONDITION_DESCRIPTION
                                                                        }} left </p>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div class="ui-g-12 ui-md-12 ui-lg-6">
                                                    <ng-container *ngIf="isFollowUp()">
                                                        <div class="ui-g-12">
                                                            <div class="ui-g-12 ui-md-6">
                                                                <p>Specialty :</p>
                                                            </div>
                                                            <div class="ui-g-12 ui-md-6">
                                                                <ng-container *ngIf="
                                    this.consultation.other_data
                                      .selectedClosedConsultation
                                  ">
                                                                    <p *ngFor="
                                      let appointment of this.consultation
                                        .other_data.selectedClosedConsultation
                                        .p_consultation_appointment
                                    ">
                                                                        {{
                                                                        appointment.d_specialty_type
                                                                        .specialty_name
                                                                        }}
                                                                    </p>
                                                                </ng-container>
                                                            </div>
                                                        </div>
                                                        <div class="ui-g-12">
                                                            <div class="ui-g-12 ui-md-6">
                                                                <p>Doctor :</p>
                                                            </div>
                                                            <div class="ui-g-12 ui-md-6">
                                                                <ng-container *ngIf="
                                    this.consultation.other_data
                                      .selectedClosedConsultation
                                  ">
                                                                    <p *ngFor="
                                      let appointment of this.consultation
                                        .other_data.selectedClosedConsultation
                                        .p_consultation_appointment
                                    ">
                                                                        {{
                                                                        'Dr. ' +
                                                                        appointment.egd_users.first_name +
                                                                        '
                                                                        ' +
                                                                        (appointment.egd_users.middle_name==null?'':appointment.egd_users.middle_name)
                                                                        +
                                                                        '
                                                                        ' +
                                                                        appointment.egd_users.last_name
                                                                        }}
                                                                    </p>
                                                                </ng-container>
                                                            </div>
                                                        </div>
                                                        <div class="ui-g-12">
                                                            <div class="ui-g-12 ui-md-6">
                                                                <p>Consultation Date :</p>
                                                            </div>
                                                            <div class="ui-g-12 ui-md-6">
                                                                <ng-container *ngIf="
                                    this.consultation.other_data
                                      .selectedClosedConsultation
                                  ">
                                                                    <p>
                                                                        {{
                                                                        this.consultation.other_data
                                                                        .selectedClosedConsultation
                                                                        .consultation_date | date
                                                                        }}
                                                                    </p>
                                                                </ng-container>
                                                            </div>
                                                        </div>
                                                    </ng-container>

                                                    <ng-container *ngIf="
                              this.consultation.other_data.slotsFetch.other_data
                                .is_display;
                              else askSlots
                            ">
                                                        <div class="ui-g-12">
                                                            <app-time-slots [(timeSlotsData)]="
                                  this.consultation.other_data.slotsFetch
                                    .timeSlots
                                " (date_selected)="onSlotsDateChanged($event)"
                                                                (slot_id_selected)="onSlotSelected($event)"></app-time-slots>
                                                        </div>
                                                    </ng-container>

                                                    <ng-template #askSlots>
                                                        <div class="ui-g-12">
                                                            <p-checkbox name="slot_doctor_choose" [(ngModel)]="
                                  this.consultation.consultApiData
                                    .slot_doctor_choose
                                " [binary]="true" #slot_doctor_choose="ngModel"
                                                                (click)="this.consultation.clear_slots()"
                                                                [required]="true">
                                                            </p-checkbox>
                                                            <label for="slot_doctor_choose">
                                                                Let Doctor Choose the slot
                                                            </label>
                                                        </div>

                                                        <ng-container *ngIf="
                                !this.consultation.consultApiData
                                  .slot_doctor_choose
                              ">
                                                            <div class="ui-g-12">
                                                                <label for="slots">
                                                                    Please Provide your slots :
                                                                </label>
                                                            </div>
                                                            <div class="ui-g-12">
                                                                <div class="ui-g-12">Slot :</div>

                                                                <div class="ui-g-12">
                                                                    <div class="ui-g-12 ui-md-3">
                                                                        <label for="from_1">
                                                                            From<span class="req">*</span>:
                                                                        </label>
                                                                    </div>
                                                                    <div class="ui-g-12 ui-md-9">
                                                                        <p-calendar class="notranslate" name="form_1"
                                                                            id="from_1" [showTime]="true"
                                                                            hourFormat="12" [(ngModel)]="
                                        this.consultation.consultApiData
                                          .slot1_primary_from
                                      " #fromslot1="ngModel" [stepMinute]="30" [minDate]="
                                        this.consultation.other_data.minDays
                                      " [maxDate]="
                                        this.consultation.other_data.maxDays
                                      " [showIcon]="true" [defaultDate]="
                                        this.consultation.other_data.minDays
                                      " inputId="time" [disabled]="
                                        this.consultation.consultApiData
                                          .slot_doctor_choose
                                      " [required]="
                                        !this.consultation.consultApiData
                                          .slot_doctor_choose
                                      ">
                                                                        </p-calendar>

                                                                        <div *ngIf="
                                        fromslot1.invalid &&
                                        (fromslot1.dirty ||
                                          fromslot1.touched) &&
                                        this.consultation.consultApiData
                                          .slot_doctor_choose == false
                                      " class="alert alert-danger">
                                                                            <div *ngIf="fromslot1.errors.required"
                                                                                class="alert alert-danger">
                                                                                From Slot 1 is required.
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="ui-g-12">
                                                                    <div class="ui-g-12 ui-md-3">
                                                                        <label for="till_1">
                                                                            Till<span class="req">*</span>:
                                                                        </label>
                                                                    </div>
                                                                    <div class="ui-g-12 ui-md-9">
                                                                        <p-calendar class="notranslate" name="till_1"
                                                                            id="till_1" [showTime]="true"
                                                                            hourFormat="12" [(ngModel)]="
                                        this.consultation.consultApiData
                                          .slot1_primary_to
                                      " #toslot1="ngModel" [stepMinute]="30" [minDate]="
                                        this.consultation.other_data.minDays
                                      " [maxDate]="
                                        this.consultation.other_data.maxDays
                                      " [showIcon]="true" [defaultDate]="
                                        this.consultation.other_data.minDays
                                      " inputId="time" [disabled]="
                                        this.consultation.consultApiData
                                          .slot_doctor_choose
                                      " [required]="
                                        !this.consultation.consultApiData
                                          .slot_doctor_choose
                                      ">
                                                                        </p-calendar>

                                                                        <div *ngIf="
                                        toslot1.invalid &&
                                        (toslot1.dirty || toslot1.touched) &&
                                        this.consultation.consultApiData
                                          .slot_doctor_choose == false
                                      " class="alert alert-danger">
                                                                            <div *ngIf="toslot1.errors.required"
                                                                                class="alert alert-danger">
                                                                                Till Slot 1 is required.
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="ui-g-12 text-center">
                                                                    <div *ngIf="slotDate(12)">
                                                                        <div class="alert alert-danger">
                                                                            Invalid Date and Time.
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </ng-template>
                                                </div>
                                                <div *ngIf="!isPackageSpecialty()">
                                                    <ng-container *ngIf="
                              !this.consultation.other_data
                                .user_packages_list_api_result.Posting ||
                              this.consultation.other_data
                                .priority_list_api_result.Posting
                            ">
                                                        <ng-container *ngIf="
                                !isNutritionAndHealthConsultation() &&
                                this.consultation.other_data.priority_list
                                  ?.length > 0
                              ">
                                                            <div class="ui-g-12">
                                                                <div class="ui-g-12">
                                                                    <label for="doctor_origin">
                                                                        Doctor Region<span class="req">*</span>:
                                                                    </label>
                                                                </div>

                                                                <div class="ui-g-12">
                                                                    <div class="ui-g-12 ui-md-6 ui-lg-6" *ngFor="
                                      let priority of this.consultation
                                        .other_data.priority_list
                                    ">
                                                                        <p-radioButton class="notranslate"
                                                                            name="consultation_priority_type_id"
                                                                            id="consultation_priority_type_id"
                                                                            [value]="priority.id" [label]="
                                        isPay()
                                          ? priority.price_label
                                          : priority.no_price_label
                                      " [(ngModel)]="
                                        this.consultation.consultApiData
                                          .priority_type_id
                                      " #consultation_priority_type_id="ngModel" (click)="dirty()" [disabled]="
                                        isPosting() ||
                                        this.consultation.other_data
                                          .packageConsultDoctor.otherData
                                          .priorityDisabled
                                      " required>
                                                                        </p-radioButton>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </p-fieldset>

                                <div class="ui-g-12 text-align-right">
                                    <p-button type="button" [style]="{
                      'margin-right': '5px',
                      'margin-top': '3px',
                      'background-color': 'white',
                      color: '#004AAD',
                      'border-radius': '5px'
                    }" [routerLink]="['/', this.slug, 'patient']" [disabled]="isPosting()" label="Cancel"
                                        class="p-button-lg p-button-danger" icon="pi pi-times"></p-button>
                                    <p-button type="submit" [style]="{
                      'margin-right': '5px',
                      'border-radius': '5px',
                      'margin-top': '3px'
                    }" [disabled]="
                      isNextDisabled() ||
                      !this.consultDoctorForm.valid ||
                      isPosting()
                    " label="Save and Continue" class="p-button-lg" icon="pi pi-check">
                                    </p-button>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </form>
        </p-tabPanel>
        <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Paid Diet Plan" leftIcon="pi pi-pencil">
            <form accept-charset="UTF-8" #paidDietForm="ngForm" (submit)="nextTab()">
                <div class="ui-g">
                    <div class="ui-g-12">
                        <h2 class="heading2 egd-theme-text">
                            Book an Appointment with a Nutrition Coach
                        </h2>
                        <div class="ui-g">
                            <div class="ui-g-12">
                                <div class="ui-g-12">
                                    <label for="health_goal">
                                        <b>Diet Preference <span class="req">*</span>:</b>
                                    </label>
                                </div>
                                <div class="ui-g-12">
                                    <p-dropdown id="diet_preference" [(ngModel)]="
                      this.consultation.consultApiData.diet_preferrence_id
                    " placeholder="Select" [options]="this.consultation.other_data.dietPreferenceData"
                                        #diet_preference="ngModel" name="diet_preference" [required]="true">
                                    </p-dropdown>
                                    <div *ngIf="
                      diet_preference.invalid &&
                      (diet_preference.dirty || diet_preference.touched)
                    " class="alert alert-danger">
                                        <div *ngIf="diet_preference.errors.required" class="alert alert-danger">
                                            Diet Preference is required.
                                        </div>
                                    </div>
                                </div>

                                <ng-container *ngIf="isOtherDietPreference()">
                                    <div class="ui-g-12">
                                        <input id="other_diet_preference" type="text" pInputText
                                            [pKeyFilter]="this.consultation.regExp.name_input" style="
                        width: 260px;
                        border-color: rgb(16, 151, 16);
                        color: black;
                        opacity: inherit;
                      " name="other_diet_preference" placeholder="Other Diet Preference"
                                            #other_diet_preference="ngModel" [(ngModel)]="
                        this.consultation.consultApiData.other_diet_preferrence
                      " class="form-check-input" required />
                                        <div *ngIf="
                        other_diet_preference.invalid &&
                        (other_diet_preference.dirty ||
                          other_diet_preference.touched)
                      " class="alert alert-danger">
                                            <div *ngIf="other_diet_preference.errors.required"
                                                class="alert alert-danger">
                                                Other Diet Preference is required.
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>

                            <div class="ui-g-12" *ngIf="!isFreeDietConsultation()">
                                <div class="ui-g-12">
                                    <p-checkbox name="preferred_dietition_checkbox" [(ngModel)]="
                      this.consultation.consultApiData.choose_dietition
                    " [binary]="true" #preferred_dietition_checkbox="ngModel"
                                        (click)="this.consultation.clear_preferred_dietition()" [required]="true">
                                    </p-checkbox>
                                    <label class="pl-10px" for="preferred_dietition_checkbox">
                                        <b>Choose your preferred dietician:</b>
                                    </label>
                                </div>
                                <div class="ui-g-12" *ngIf="this.consultation.consultApiData.choose_dietition">
                                    <p-dropdown class="notranslate" id="preferred_dietition" [(ngModel)]="
                      this.consultation.consultApiData.preferred_user_guid
                    " placeholder="Select" [options]="
                      this.consultation.other_data.preferredDieticianData
                    " #preferred_dietition="ngModel" name="preferred_dietition" [required]="
                      this.consultation.consultApiData.choose_dietition
                    ">
                                    </p-dropdown>

                                    <div *ngIf="
                      preferred_dietition.invalid &&
                      (preferred_dietition.dirty || preferred_dietition.touched)
                    " class="alert alert-danger">
                                        <div *ngIf="preferred_dietition.errors.required" class="alert alert-danger">
                                            Please choose your preferred dietician.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="ui-g-12">
                                <div class="ui-g-12">
                                    <label for="health_goal">
                                        <b>Enter your Health Goals <span class="req">*</span>:</b>
                                    </label>
                                </div>
                                <div class="ui-g-12 ui-md-6">
                                    <textarea [pKeyFilter]="this.consultation.regExp.textarea"
                                        [(ngModel)]="this.consultation.consultApiData.health_goal" name="health_goal"
                                        class="WordWrap format-lines textarea-input height-100px btn-text-box"
                                        placeholder="Enter your Health Goals"
                                        [maxlength]="this.consultation.const_data.DIET_HEALTH_GOAL" pInputTextarea
                                        #health_goal="ngModel" name="health_goal" required></textarea>
                                    <div *ngIf="
                      health_goal.invalid &&
                      (health_goal.dirty || health_goal.touched)
                    " class="alert alert-danger">
                                        <div *ngIf="health_goal.errors.required" class="alert alert-danger">
                                            Health Goals is required.
                                        </div>
                                    </div>
                                    <div class="ui-g-12">
                                        <p [style.color]="
                        this.consultation.consultApiData.health_goal.length -
                          (this.consultation.const_data.DIET_HEALTH_GOAL - 1) >
                        0
                          ? 'red'
                          : 'green'
                      ">
                                            {{
                                            this.consultation.const_data.DIET_HEALTH_GOAL +
                                            1 -
                                            this.consultation.consultApiData.health_goal.length < 0 ? 0 :
                                                this.consultation.const_data.DIET_HEALTH_GOAL -
                                                this.consultation.consultApiData.health_goal.length }} of {{
                                                this.consultation.const_data.DIET_HEALTH_GOAL }} left </p>
                                    </div>
                                </div>
                            </div>

                            <div class="ui-g-12 text-align-right">
                                <p-button type="button" [style]="{
                    'margin-right': '5px',
                    'margin-top': '3px',
                    'background-color': 'white',
                    color: '#004AAD',
                    'border-radius': '5px'
                  }" (click)="prevTab()" [disabled]="isPosting()" label="Back" class="p-button-lg"
                                    icon="pi pi-arrow-left">
                                </p-button>
                                <p-button type="submit" [style]="{
                    'margin-right': '5px',
                    'border-radius': '5px',
                    'margin-top': '3px'
                  }" [disabled]="
                    isNextDisabled() || !this.paidDietForm.valid || isPosting()
                  " label="Save and Continue" class="p-button-lg" icon="pi pi-check">
                                </p-button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </p-tabPanel>

        <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Offers and Discounts" leftIcon="pi pi-pencil">
            <div class="ui-g">
                <div class="ui-g-12">
                    <h2 class="heading2 egd-theme-text">Offers and Discounts</h2>
                </div>
                <div class="ui-g-12" *ngIf="
            this.consultation.other_data.offers &&
            this.consultation.other_data.offers.length
          ">
                    <p class="heading3 egd-theme-text">
                        &#9654; Select To Avail Additional Services :
                    </p>
                    <div class="ui-g-12">
                        <div class="ui-g-12 ui-md-6 ui-lg-3" *ngFor="let offer of this.consultation.other_data.offers">
                            <p-card header="{{ offer.consultation_name }}" subheader="{{
                  renderAmount(offer.amount, offer.country.currency_type)
                }}" [style]="getCardBorder('additional_offer', offer.id)" styleClass="p-card-shadow">
                                <p style="text-align: left; white-space: pre-line">
                                    {{ offer.description }}
                                </p>
                                <div class="p-p-3" style="margin-top: 4%">
                                    <button pButton pRipple type="button" [label]="
                      this.consultation.other_data.selected_additional_offer ==
                      offer.id
                        ? 'Selected'
                        : 'Select'
                    " (click)="additonalOffersBtn(offer.id)"></button>
                                </div>
                            </p-card>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="this.consultation.other_data.discountCodeList.length >= 1">
                    <div class="ui-g-12">
                        <p class="heading3 egd-theme-text">
                            &#9654; Click To Apply Discount Code :
                        </p>
                        <div class="ui-g-12" *ngIf="this.consultation.other_data.discountCodeList.length > 3">
                            <button pButton pRipple type="button" [label]="
                  this.consultation.other_data.coupon_code_data.show_all
                    ? 'View Less'
                    : 'View More'
                " (click)="discountCodeViewBtn()"></button>
                        </div>
                        <div class="ui-g-12">
                            <div class="ui-g-12 ui-md-6 ui-lg-3" *ngFor="
                  let code of this.consultation.other_data.discountCodeList
                    | slice
                      : 0
                      : this.consultation.other_data.coupon_code_data
                          .current_list_count
                ">
                                <p-card header="{{ code.discount_code }}"
                                    subheader="{{ code.egd_referral_master_type.referral_type }}"
                                    [style]="getCardBorder('discount_code', code.discount_id)"
                                    styleClass="p-card-shadow">
                                    <p>
                                        Use Code {{ code.discount_code }} To Get
                                        <b>{{ code.discount_percent }}%</b>
                                        Off On Your Checkout Price
                                    </p>
                                    <div class="p-p-3" style="margin-top: 4%">
                                        <button pButton pRipple type="button" [label]="
                        this.consultation.consultApiData.discount_id ==
                        code.discount_id
                          ? 'APPLIED'
                          : 'APPLY'
                      " (click)="
                        discountCodeBtn(code.discount_id, code.discount_code)
                      " icon="pi pi-check"></button>
                                    </div>
                                </p-card>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div class="ui-g-12">
                    <input id="discount_code_input" type="text" pInputText style="
              width: 260px;
              border-color: rgb(16, 151, 16);
              color: black;
              opacity: inherit;
            " [disabled]="
              this.consultation.other_data.discount_code_apply_api_result
                .Posting
            " name="discount_code_input" placeholder="Enter Discount Code" [(ngModel)]="
              this.consultation.other_data.coupon_code_data.discount_code_api
                .discount_code
            " class="form-check-input btn-text-box" />
                </div>
                <div class="ui-g-12">
                    <button pButton pRipple type="button" style="border-radius: 5px" label="Apply" [disabled]="
              this.consultation.other_data.discount_code_apply_api_result
                .Posting
            " (click)="discountCodeApplyBtn()"></button>
                    <app-loading *ngIf="
              this.consultation.other_data.discount_code_apply_api_result
                .Posting
            " type="SMALL_LOADER"></app-loading>
                </div>
                <div class="ui-g-12">
                    <app-error-messages [api_result]="
              this.consultation.other_data.discount_code_apply_api_result
            ">
                    </app-error-messages>
                </div>
                <div class="ui-g-12 text-align-right">
                    <p-button type="button" [style]="{
              'margin-right': '5px',
              'margin-top': '3px',
              'background-color': 'white',
              color: '#004AAD',
              'border-radius': '5px'
            }" (click)="prevTab();handleClearMessages()" label="Back" class="p-button-lg" icon="pi pi-arrow-left">
                    </p-button>
                    <p-button type="button" [style]="{
              'margin-right': '5px',
              'border-radius': '5px',
              'margin-top': '3px'
            }" label="Save and Continue" class="p-button-lg" icon="pi pi-check"
                        (click)="nextTab();handleClearMessages()">
                    </p-button>
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Payment" leftIcon="pi pi-pencil">
            <div class="ui-g">
                <div class="ui-g-12">
                    <h2 class="heading2 egd-theme-text">Payment</h2>
                </div>
                <app-payment class="ui-g-12" *ngIf="isPay()" [payment_data]="this.consultation.other_data.payment_data"
                    (payment_success)="onPaymentSuccess($event)"></app-payment>
                <div *ngIf="!isPosting()" class="ui-g-12 text-align-right">
                    <p-button type="button" [style]="{
              'margin-right': '5px',
              'background-color': 'white',
              color: '#004AAD',
              'border-radius': '5px'
            }" (click)="prevTab()" label="Back" class="p-button-lg" icon="pi pi-arrow-left">
                    </p-button>
                </div>
            </div>
        </p-tabPanel>
        <p-tabPanel headerStyleClass="tabview-tab-d-none" header="Transaction Successful" leftIcon="pi pi-pencil">
            <ng-container *ngIf="isPay()">
                <p-dialog *ngIf="this.consultation.other_data.print_data.displayModal" header="Invoice"
                    [(visible)]="this.consultation.other_data.print_data.displayModal" [modal]="true"
                    [style]="{ width: '50vw' }">
                    <div class="ui-g-12">
                        <app-loading type="LOADING_DATA"
                            *ngIf="this.consultation.other_data.print_data.api_result.Posting">
                        </app-loading>
                    </div>
                    <ng-container *ngIf="
              !this.consultation.other_data.print_data.api_result.Posting &&
              this.consultation.other_data.print_data.api_result.PromiseResult
                .success != null &&
              this.consultation.other_data.print_data.api_result.PromiseResult
                .success
            ">
                        <div class="ui-g-12">
                            <p-button icon="pi pi-check" (click)="print()" label="Print" styleClass="p-button-text">
                            </p-button>
                        </div>
                        <div *ngIf="
                this.consultation.other_data.print_data.api_result.PromiseResult
                  .success != null &&
                this.consultation.other_data.print_data.api_result.PromiseResult
                  .success
              ">
                            <div class="spaces"></div>
                            <app-invoicedetails class="notranslate"
                                [data]="this.consultation.other_data.print_data.data"
                                [dataId]="this.consultation.other_data.print_data.showInvoice">
                            </app-invoicedetails>
                        </div>
                    </ng-container>
                </p-dialog>

                <div *ngIf="
            this.consultation.other_data.print_data.api_result.PromiseResult
              .success != null &&
            this.consultation.other_data.print_data.api_result.PromiseResult
              .success
          ">
                    <div class="spaces"></div>
                    <app-invoicedetails class="notranslate" [data]="this.consultation.other_data.print_data.data"
                        [dataId]="this.consultation.other_data.print_data.printContent">
                    </app-invoicedetails>
                </div>
            </ng-container>

            <div class="ui-g text-center">
                <div class="ui-g-12">
                    <img src="assets/images/thank-you/successful.gif" alt="" class="successful-logo" />
                </div>
                <div class="ui-g-12">
                    <h2 class="egd-theme-text">Thank you for booking the consultation</h2>
                </div>
                <div class="ui-g-12">
                    <p>Transaction is successful</p>
                    <p>Welcome User,</p>
                    <p>
                        Thank you for contacting eGlobalDoctors.
                        <b>Your Request Number is <span class="notranslate">
                                {{
                                this.consultation.other_data.payment_data.paymentSuccessData
                                .consultationData.consultation_request_number
                                }}</span>
                            .</b>
                    </p>
                    <p>
                        One of our expert Doctors will reach out to you according to your
                        priority.
                    </p>
                    <p>
                        You can always track your requests in the "Track Request" section of
                        your profile.
                    </p>
                    <p class="alert alert-danger">
                        Note: It is mandatory that you provide your Medical History and
                    </p>
                    <p class="alert alert-danger">
                        upload your Medical Records before a doctor can talk to you.
                    </p>
                    <p class="alert alert-danger">
                        Click on Upload and Edit Details button to provide Patient Medical History
                    </p>
                    <div class="ui-g-12 transaction-success-buttons">
                        <button pButton class="button-size" type="button" style="margin-right: 5px"
                            label="Upload and Edit Details"
                            (click)="RouterNavigation( '/' + 'uploadandeditdocuments')"></button>
                        <!-- <button
              pButton
              class="button-size"
              *ngIf="isPay()"
              type="button"
              style="margin-right: 5px"
              label="Print Invoice"
              icon="pi pi-print"
              (click)="openInvoice()"
            ></button> -->
                        <button pButton class="button-size" type="button" style="margin-right: 5px"
                            label="Navigate to Transactions" (click)="RouterNavigation('/' +'transactions')"></button>
                        <button pButton class="button-size" type="button" label="Navigate to Dashboard"
                            (click)="RouterNavigation('/' +'dashboard')"></button>
                    </div>
                </div>
            </div>
        </p-tabPanel>
    </p-tabView>

    <div class="ui-g-12">
        <app-error-messages [api_result]="this.consultation.other_data.submit_consultation_api_result">
        </app-error-messages>
    </div>

    <div class="ui-g-12">
        <app-loading type="LOADING_DATA" *ngIf="isPosting()"></app-loading>
    </div>
    <ng-container *ngIf="isConsultationSelected()">
        <div class="ui-g-12">
            <p class="m-3" *ngIf="
          this.consultation.patient_state[
            this.consultation.consultApiData.patient_guid
          ] == 4637
        ">
                <b>Note: eGlobalDoctors partners with pharmacies for the delivery of
                    medicines. Address details for pickups are provided with the
                    prescriptions. You can opt for a different pharmacy of your choice.</b>
            </p>
            <p-fieldset [style]="{
          width: '100%',
          border: '1px solid #000000',
          'text-align': 'justify'
        }">
                <p-header>
                    <b>Disclaimer</b>
                    <span class="alert alert-danger">*</span>
                </p-header>
                <p class="disclaimer-text">
                    Our opinion is an advisory service providing online healthcare
                    evaluations designed to increase the awareness of patients and their
                    treating physicians. All medical evaluations, opinions and/or
                    recommendations contained within the Get a Second Opinion Report are
                    based on the health-related information and medical reports, records,
                    images, and/or results provided directly by the User, or otherwise
                    obtained by us as authorized by User, and in no way should be
                    constructed to be determinative of the treatment to be pursued by any
                    treating physician. Only the patient with input from his/her
                    healthcare provider may decide if this Get a Second Opinion Service
                    would be beneficial to the Patient's medical treatment. Ask your
                    healthcare provider if any recommended treatment protocol may benefit
                    from the input of our Physicians.
                </p>
            </p-fieldset>
        </div>
    </ng-container>
</div>